/**
 * A component to select from a list of templates, fill in variables for that template, and see a
 * real-time preview of the template.
 */
import handlebars from 'handlebars/dist/handlebars';
import Papa from 'papaparse';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Box } from 'signoxe/components/layout';
import { WebTemplateVariableView } from '..';
import { addTemplateMetadata, getTemplateMetadata } from '../../utils/template';
import './styles.scss';

class WebAssetTemplateEditor extends Component {
  constructor(props) {
    super(props);
    this.state = WebAssetTemplateEditor.initialState;
    const initialData = getTemplateMetadata(this.props.content);

    this.state = this.getTemplateRenderState(initialData.id, initialData.values);
  }

  static initialState = {
    selected: 'NULL',
    template: '',
    vars: [],
    values: {},
    help: '',
    rendered: '',
  };

  static propTypes = {
    templates: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      template: PropTypes.string.isRequired,
      variables: PropTypes.string.isRequired,
    })).isRequired,
    content: PropTypes.string,
    dataAsset: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
  };

  handleDataChange = (data) => this.handleVarChange('data', data.data);

  handleFileSelect = (file) =>
    Papa.parse(file, {complete: this.handleDataChange, skipEmptyLines: true})

  /**
   * Update state if template selection changes.
   * @param event
   */
  handleTemplateChange = (event) => {
    const selected = event.target.selectedOptions[0].value;
    const newState = this.getTemplateRenderState(selected, this.state.values);

    this.props.onChange(newState.rendered);
    this.setState(newState);
  }

  /**
   * Update state if a single variable changes.
   * @param varName
   * @param value
   */
  handleVarChange = (varName, value) => {
    const values = {
      ...this.state.values,
      [varName]: value,
    };
    const newState = this.getTemplateRenderState(this.state.selected, values);

    console.log('Rendered state ', newState.rendered)

    this.props.onChange(newState.rendered);
    this.setState(newState);
  }

  /**
   * Builds the template context which is essentially a clone of values, but with missing variable
   * values filled in with placeholder text.
   * @param vars
   * @param values
   * @returns {{}}
   */
  getTemplateContext(vars, values) {
    const templateContext = {};

    vars.forEach(name =>
      templateContext[name] =
        (values && values[name]) ? values[name] : `{${name} will show up here}`,
    );

    if (this.props.dataAsset) {
      templateContext.data = values && values.data
        ? values.data
        : [['{Column 1}', '{Column 2}'],
          ['{Sample Data 1}', '{Sample Data 2}']];
    }

    return templateContext;
  }

  /**
   * Looks up the template by id in the list of templates provided, and selects it.
   * @param templateId
   */
  getTemplateData(templateId) {
    const templateData = this.props.templates.find(t => t.id == templateId);

    if (templateData) {
      const vars = templateData.variables.split(',');

      return {
        template: templateData.template,
        vars,
        help: templateData.help_html,
      };
    } else {
      return WebAssetTemplateEditor.initialState;
    }
  }

  /**
   * Renders the provided template using the provided parameters and updates the state.
   * @param tplId
   * @param values
   */
  getTemplateRenderState(tplId, values) {
    const {template, vars, help} = this.state.selected == tplId
      ? this.state // The template hasn't changed, use values cached in state.
      : this.getTemplateData(tplId); // The template has changed, fetch data for this template.
    const context = this.getTemplateContext(vars, values);

    let rendered = handlebars.compile(template)(context);
    // Adds template metadata that will help us detect the template used by a web asset and the
    // variable values embedded in it.

    rendered = addTemplateMetadata(rendered, tplId, values);

    return {selected: tplId, vars, values, template, rendered, help};
  }

  render() {
    const {templates} = this.props;
    const {vars, values, help, rendered, selected} = this.state;

    return (
      <Box direction="row" className="web-template-editor wrap-for-small">
        <Box direction="column" className="template-form">
          <select id="template-selector" name="template-selector"
                  value={selected}
                  onChange={this.handleTemplateChange}>
            <option value="NULL" key="null">----</option>
            {templates.map(template =>
              (<option key={template.id}
                       value={template.id}>{template.name}</option>),
            )}
          </select>
          {selected &&
          <WebTemplateVariableView vars={vars}
                                   help={help}
                                   dataFile={this.props.dataAsset}
                                   values={values}
                                   onVarChange={this.handleVarChange}
                                   onDataFileChange={this.handleFileSelect}/>
          }
        </Box>
        <div className="web-template-view">
          <iframe srcDoc={rendered}/>
        </div>
      </Box>
    );
  }
}

export default WebAssetTemplateEditor;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/WebAssetTemplateEditor/index.js